module.exports = __webpack_public_path__ + "static/printer-27384641abb7491d9f58fb7ea33ef1b1.jpg";